import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p402978057726517248',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
